
import { config, debug, i18n, inject, observer, React, Route, RouteComponentProps, ui } from "aaa";
import auth from "stores/AuthStore";
import { ExternalInterfaceStore } from "stores/ExternalInterfaceStore";
import { pushRoute } from "stores/RouterFunctions";
import { ErrorScreen } from "../common/ErrorScreen";
import { QuickDrawdownConfiguration } from "./QuickDrawdownConfiguration";
import { QuickDrawdownSigning } from "./QuickDrawdownSigning";
import { QuickDrawdownStore } from "./QuickDrawdownStore";
import { QuickDrawdownSuccess } from "./QuickDrawdownSuccess";

type IProps = RouteComponentProps<{}> & i18n.InjectedIntlProps & {
    externalInterfaceStore: ExternalInterfaceStore;
};

@i18n.injectIntl
@inject("externalInterfaceStore")
@observer
export class QuickDrawdownContainer extends React.Component<IProps, {}> {
    store: QuickDrawdownStore;

    constructor(props: any) {
        super(props);
        this.store = new QuickDrawdownStore();
    }

    async componentDidMount() {
        try {
            if (auth.authorized && this.props.externalInterfaceStore.currentCardId) {
                await this.store.load(this.props.externalInterfaceStore.currentCardId);
            }
        } catch (error) {
            debug.log("### Container.componentDidMount() Failed to load data", error);
            if (!config.DEBUG) {
                pushRoute(this.props.match.path + "/error");
            }
        }
    }

    withStore(Component: any) {
        return () => <Component {...this.props} store={this.store} />;
    }

    withBadRequestMessage(Component: any) {
        if (this.store.badRequestMessage) {
            return () => <Component {...this.props} message={this.store.badRequestMessage} />;
        } else {
            return Component;
        }
    }

    render() {
        document.title = ui.__("quickDrawdown.document.title");

        return (
            <div>
                <Route exact path={this.props.match.path} render={this.withStore(QuickDrawdownConfiguration)} />
                <Route path={this.props.match.path + "/signing"} render={this.withStore(QuickDrawdownSigning)} />
                <Route path={this.props.match.path + "/success"} render={this.withStore(QuickDrawdownSuccess)} />
                <Route path={this.props.match.path + "/error"} component={this.withBadRequestMessage(ErrorScreen)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/quickDrawdown/QuickDrawdownContainer.tsx